import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TenantDataTab } from "./TenantDataTab";
import { TenantCustomizationTab } from "./TenantCustomizationTab";
import { TenantStatsTab } from "./TenantStatsTab";
import { TenantSubscriptionTab } from "./TenantSubscriptionTab";

interface TenantDetailsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tenant: {
    id: string;
    name: string;
    slug: string;
    email: string | null;
    status: string;
    trial_ends_at: string | null;
    created_at: string;
    subscription_status: string | null;
    subscription_plan_id: string | null;
    subscription_type: string | null;
    subscription_payment_method: string | null;
    subscription_start_date: string | null;
    subscription_next_billing_date: string | null;
    subscription_last_payment_date: string | null;
    colors: any;
    images: any;
  };
}

export function TenantDetailsModal({ open, onOpenChange, tenant }: TenantDetailsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl p-0 overflow-hidden">
        <div className="flex max-h-[90vh] flex-col pb-5">
          <DialogHeader className="sticky top-0 z-10 bg-background px-6 py-4 border-b">
            <DialogTitle className="text-2xl">Detalhes do Cliente: {tenant.name}</DialogTitle>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto px-6">
            <Tabs defaultValue="data" className="w-full">
              <TabsList className="grid w-full grid-cols-4 sticky top-0 z-10 bg-background mb-4 mt-4">
                <TabsTrigger value="data">Dados</TabsTrigger>
                <TabsTrigger value="customization">Personalização</TabsTrigger>
                <TabsTrigger value="stats">Estatísticas</TabsTrigger>
                <TabsTrigger value="subscription">Assinatura</TabsTrigger>
              </TabsList>

              <TabsContent value="data" className="space-y-4 mt-4">
                <TenantDataTab tenant={tenant} />
              </TabsContent>

              <TabsContent value="customization" className="space-y-4 mt-4">
                <TenantCustomizationTab tenant={tenant} />
              </TabsContent>

              <TabsContent value="stats" className="space-y-4 mt-4">
                <TenantStatsTab tenantId={tenant.id} />
              </TabsContent>

              <TabsContent value="subscription" className="space-y-4 mt-4">
                <TenantSubscriptionTab tenant={tenant} onUpdate={() => onOpenChange(false)} />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
